import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { memo, useEffect, useRef, useState } from "react"
import { Modal } from "react-bootstrap"
import CustomButton from "../CustomButton"
import CustomInput from "../CustomInput"
import "./style.css"

const FormModal = (props) => {

    const {
        open,
        toggle,
        title,
        onSubmit,
        inputs = [],
        children
    } = props

    const image_input = useRef()

    const initialErrors = inputs?.reduce((acc, field) => {
        acc[field.id] = '';
        return acc;
    }, {});

    const [formValues, setFormValues] = useState([]);
    const [formErrors, setFormErrors] = useState(initialErrors);

    useEffect(() => {

        const initialValues = inputs.reduce((acc, field) => {
            acc[field.id] = (field?.type !== "image" ? field?.initialValue : null) || (field?.multiple ? [] : "");
            return acc;
        }, {});

        setFormValues(initialValues)

    }, [inputs])

    const validate = () => {
        const errors = {};
        inputs.forEach(field => {
            const value = formValues[field.id];
            if (field.required && !value) {
                errors[field.id] = `${field.label} is required`;
            } else if (field.type === 'email' && value && !/\S+@\S+\.\S+/.test(value)) {
                errors[field.id] = 'Invalid email address';
            } else if (field.type === 'number') {
                if (field.min && value < field.min) {
                    errors[field.id] = `${field.label} must be at least ${field.min}`;
                }
            } else {
                errors[field.id] = '';
            }
        });
        setFormErrors(errors);
        return Object.values(errors).every(error => !error); // Returns true if there are no errors
    };

    const handleChange = (event) => {
        const { id, value, type, files } = event.target;

        let multiple = inputs[id]?.multiple

        let obj = {
            ...formValues,
            [id]: value
        }

        if (type === "file") {
            obj = {
                ...formValues,
                [id]: files[0]
            }
        } else if (type === "checkbox") {

            let existing_values = [...formValues[id]]
            let index = existing_values.indexOf(Number(value))

            if (index > -1) {
                existing_values.splice(index, 1);
            } else {
                existing_values.push(Number(value))
            }

            obj = {
                ...formValues,
                [id]: existing_values
            }

        }

        setFormValues(obj);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (validate()) {
            onSubmit(formValues)
        }
    };

    return (
        <Modal
            show={open}
            onHide={toggle}
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    inputs?.map(field => (
                        field?.type === "image" ?
                            <>
                                <label className={"mainLabel"}>{field?.label}<span className="text-danger">{field?.required ? ' *' : ''}</span></label>
                                <div onClick={() => image_input.current.click()} className="image-wrapper">
                                    {
                                        formValues[field.id] ? <img src={URL.createObjectURL(formValues[field.id])} className="image" /> :
                                            field?.initialValue ? <img src={field?.initialValue} className="image" /> :
                                                <FontAwesomeIcon icon={faPlus} size={100} />
                                    }
                                </div>
                                <input id={field.id} type="file" hidden ref={image_input} accept="image/*" onChange={handleChange} />
                                {formErrors[field?.id] && <p className='mt-1 text-danger text-small'>{formErrors[field?.id]}</p>}
                            </> : field?.type === "checkboxes" ? (
                                <div className="mb-2">
                                    <label className={"mainLabel"}>{field?.label}<span className="text-danger">{field?.required ? ' *' : ''}</span></label>
                                    <div>
                                        {
                                            field?.options?.map(item => (
                                                <div className="d-flex">
                                                    <input id={field.id} type="checkbox" className="me-2" value={item.value} checked={formValues[field.id]?.includes(item.value)} onChange={handleChange} />
                                                    <p className="m-0">{item?.label}</p>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            ) :
                                <CustomInput
                                    id={field.id}
                                    type={field.type || "text"}
                                    placeholder={field.placeholder}
                                    value={formValues[field.id]}
                                    label={field.label}
                                    onChange={handleChange}
                                    labelClass='mainLabel'
                                    inputClass='mainInput'
                                    error={formErrors[field.id]}
                                    disabled={field?.disabled}
                                    required={field?.required}
                                />
                    ))
                }
                {children}
            </Modal.Body>
            {
                onSubmit &&
                <Modal.Footer className="d-flex justify-content-between" >
                    <CustomButton text="Cancel" onClick={toggle} />
                    <CustomButton text="Submit" variant="primaryButton" onClick={handleSubmit} />
                </Modal.Footer>
            }
        </Modal>
    )
}

export default memo(FormModal)